import { CircleOfFifths } from "../components/learn/CircleOfFifths";
import { EarTraining } from "../components/learn/EarTraining";
import { Explorer } from "../components/learn/Explorer";
import { PracticeProgress } from "../components/learn/PracticeProgress";
import { ProgressionGenerator } from "../components/learn/ProgressionGenerator";
import { Tuner } from "../components/learn/Tuner";

export function LearningLab() {
  return (
    <div className="workspace-grid learning">
      <Explorer />
      <CircleOfFifths />
      <ProgressionGenerator />
      <EarTraining />
      <PracticeProgress />
      <Tuner />
    </div>
  );
}
